import { Collapse, Flex, Typography } from 'antd'
import { useTheme } from 'antd-style'
import { useState } from 'react'

import {
  GetAdverseEffectEntryAdverseEffectListResponse2,
  GetTreatmentPlanAdverseEffectEntryListResponseItem
} from 'src/api/requests'
import { CollapseExpandArrow } from 'src/components'
import { formatDate } from 'src/libs'
import { useLocales } from 'src/locales'

import { PersonReactionsListChildren } from './PersonReactionsListChildren'
import { useStyles } from './styles'

const { Text } = Typography

type Props = {
  data?: GetTreatmentPlanAdverseEffectEntryListResponseItem[]
  treatmentPlanId?: string
}

const getReportedBy = (
  item: GetTreatmentPlanAdverseEffectEntryListResponseItem
) => {
  return `${item?.reportedBy?.firstName} ${item?.reportedBy?.lastName} - ${item?.legalEntity?.name}`
}

export const PersonReactionsList = ({ data, treatmentPlanId }: Props) => {
  const { t, currentLang } = useLocales()

  const { styles } = useStyles()
  const [activeKey, setActiveKey] = useState<string[]>([])

  const palette = useTheme()

  const onCollapseChange = (keys: string | string[]) => {
    setActiveKey(Array.isArray(keys) ? keys : [keys])
  }

  const items = data?.map((item) => {
    const isExpanded = activeKey.includes(String(item?.id))

    return {
      key: item?.id,
      label: (
        <Flex justify="space-between" align="center">
          <Flex gap={24}>
            <Flex gap={4}>
              <Text strong>{t('common.date')}:</Text>

              <Text>
                {item?.recordedDate ? formatDate(item?.recordedDate) : '-'}
              </Text>
            </Flex>

            {!isExpanded && (
              <>
                <Flex gap={4}>
                  <Text strong>{t('consultations.accuse')}:</Text>
                  {item?.adverseEffects
                    ?.map(
                      (item: GetAdverseEffectEntryAdverseEffectListResponse2) =>
                        item?.translation?.[currentLang?.value]
                    )
                    .join(', ')}
                </Flex>

                <Flex gap={4}>
                  <Text
                    style={{
                      color: palette.colorTextTertiary
                    }}
                  >
                    {getReportedBy(item)}
                  </Text>
                </Flex>
              </>
            )}
          </Flex>
        </Flex>
      ),
      children: (
        <PersonReactionsListChildren
          data={item}
          treatmentPlanId={treatmentPlanId}
          getReportedBy={() => getReportedBy(item)}
        />
      ),
      className: styles.collapseHeaderMargin
    }
  })

  return (
    <Collapse
      items={items}
      bordered={false}
      expandIconPosition="end"
      className={styles.collapseHeader}
      activeKey={activeKey}
      expandIcon={CollapseExpandArrow}
      onChange={onCollapseChange}
    />
  )
}
